// extracted by mini-css-extract-plugin
module.exports = {"perference":"index_perference__1aY7x"};